// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	scrollbar-color: rgba(171, 176, 187, 0.3) transparent;
	scrollbar-width: thin;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design/src/scrollbars.css"],"names":[],"mappings":"AAAA;CACC,qDAAqD;CACrD,qBAAqB;AACtB","sourcesContent":[":root {\n\tscrollbar-color: rgba(171, 176, 187, 0.3) transparent;\n\tscrollbar-width: thin;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
